import React from "react";
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import { getLanguageSection } from '../shared/services/languageService';

function DetailsFAQs() {
    const language = getLanguageSection('detailsfaqs');
    const country = Cookies.get('CountryUser');
    const currentLanguage = Cookies.get('language');
    const isSpanish = currentLanguage === 'esp';
    const showBonusTable = false;
    const tangoGiftCardInfo = (
      <div className="overflow-hidden rounded-xl border border-marival-blue bg-white">
        <div className="bg-marival-blue px-5 py-4 text-white">
          <h2 className="m-0 text-xl font-semibold leading-tight">
            {isSpanish ? '$ - Incentivo de Tarjeta de Regalo TANGO:' : '$ - TANGO Gift Card Incentive:'}
          </h2>
        </div>
        <div className="p-6 text-sm leading-7 text-marival-navy">
          <ul className="m-0 list-disc space-y-3 pl-5">
            <li>
              <b>{isSpanish ? '$100 USD vía Tarjeta de Regalo TANGO' : '$100 USD via TANGO Gift Card'}</b>
              {isSpanish ? ' por cada reserva de:' : ' for each booking of:'}
              <ul className="mt-1 list-circle space-y-1 pl-5">
                <li>
                  <b>{isSpanish ? '6 noches o más' : '6 nights or more'}</b>
                  {isSpanish ? ' en cualquiera de los tres resorts y en cualquier categoría de habitación.' : ' at any of the three resorts in any room category.'}
                </li>
                <li>
                  <b>Suites/Penthouses/Villas/Demi Pools</b>
                  {isSpanish ? ' con un ' : ' with a '}
                  <b>{isSpanish ? 'mínimo de 4 noches' : '4-night minimum'}</b>.
                </li>
              </ul>
            </li>
            <li>
              <b>{isSpanish ? '$50 USD (Armony y Distinct)' : '$50 USD (Armony and Distinct)'}</b>
              {isSpanish ? ' o ' : ' or '}
              <b>$25 USD (EMOTIONS)</b>
              {isSpanish ? ' vía Tarjeta de Regalo TANGO por cada reserva de:' : ' via TANGO Gift Card for each booking of:'}
              <ul className="mt-1 list-circle space-y-1 pl-5">
                <li><b>{isSpanish ? '3-5 noches' : '3-5 nights'}</b> {isSpanish ? '(categorías de habitación no premium).' : '(non-premium room categories).'}</li>
                <li><b>{isSpanish ? '3 noches' : '3 nights'}</b> {isSpanish ? '(Suites/Penthouses/Villas/Demi Pools) en cualquiera de las tres propiedades.' : '(Suites/Penthouses/Villas/Demi Pools) in any of the three properties.'}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
    const mexicoAwardInfo = (
      <div className="rounded-xl border border-marival-navy bg-[linear-gradient(135deg,#2f7fcb_0%,#171d54_100%)] p-6 text-white shadow-sm">
        <div className="rounded-xl border border-white/20 bg-black/15 p-5">
          <p className="m-0 text-xl font-semibold leading-8">
            {currentLanguage === 'esp'
              ? '6 Puntos = $3,000 MXN'
              : '6 Points = $200 ELECTRONIC GIFT CARD VIA TANGO'}
          </p>
          <div className="my-5 flex items-center gap-4 text-lg font-semibold uppercase text-white/90">
            <span className="h-px flex-1 bg-white/35"></span>
            <span>{currentLanguage === 'esp' ? 'O' : 'OR'}</span>
            <span className="h-px flex-1 bg-white/35"></span>
          </div>
          <p className="m-0 text-xl font-semibold leading-8">
            {currentLanguage === 'esp'
              ? '6 Puntos = 2 noches en una de las propiedades de Marival® Resorts'
              : '6 Points = 2 nights stay at a Marival® Resorts property'}
          </p>
        </div>
      </div>
    );

    const rewardRows = [
      ["Marival® Emotions Resort & Suite", language.table102, language.table101, language.table104],
      ["Marival® Emotions Resort & Suite", language.table105, language.table110, language.tablefour],
      ["Marival® Armony Luxury Resort & Suite", language.table108, language.table101, language.table104],
      ["Marival® Armony Luxury Resort & Suite", language.table111, language.table104, language.tablefour],
      ["Marival® Armony Luxury Resort and Suite", language.table114, language.table113, language.tablesix],
      ["Marival® Distinct Luxury Residences", language.table117, language.table107, language.table104],
      ["Marival® Distinct Luxury Residences", language.table120, language.table104, language.tablefour],
      ["Marival® Distinct Luxury Residences", language.table123, language.table113, language.tablesix],
    ];

    const pointsTable = (
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[560px] border-collapse text-left text-sm">
            <thead>
              <tr className="bg-marival-sky text-xs font-semibold uppercase text-white">
                <th className="px-4 py-4">Resort</th>
                <th className="px-4 py-4">{language.roomcategory}</th>
                <th className="px-4 py-4 text-center">3-6 {language.nights}</th>
                <th className="bg-[#3e89b2] px-4 py-4 text-center">7+{language.nights}</th>
              </tr>
            </thead>
            <tbody>
              {rewardRows.map((row, index) => (
                <tr className="border-t border-slate-200 bg-white" key={`${row[0]}-${index}`}>
                  <td className="px-4 py-4 text-xs font-semibold leading-5 text-marival-navy">{row[0]}</td>
                  <td className="px-4 py-4 text-xs leading-5 text-slate-500">{row[1]}</td>
                  <td className="px-4 py-4 text-center text-xs font-semibold text-marival-navy">{row[2]}</td>
                  <td className="bg-marival-sky px-4 py-4 text-center text-xs font-semibold text-white">{row[3]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );

    return (
      <div id="detailsfaqs" className="mr-ui bg-[#f3f5fb] pb-10">
        <div className="mx-auto grid w-full max-w-7xl items-start gap-5 px-5 md:px-8 lg:grid-cols-[1.15fr_1fr]">
          <section className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm md:p-7">
            <h1 className="m-0 mb-5 text-xl font-normal uppercase leading-tight text-marival-navy">
              {country === '167' ? language.text1 : (isSpanish ? 'LOS PREMIOS QUE GENERAS POR CADA RESERVA SON:' : 'The awards you will earn for every booking are:')}
            </h1>

            {country === '167' ? (
              pointsTable
            ) : (
              tangoGiftCardInfo
            )}
          </section>

          <aside className="grid gap-5">
            <section className="rounded-xl border border-orange-200 bg-[#fff1df] p-6 shadow-sm">
              <h2 className="m-0 mb-4 text-base font-normal text-marival-navy">{language.note}</h2>
              {country === '167' ? <p className="m-0 text-sm leading-7 text-slate-600">{language.noteText10}</p> : null}
              {country === '254' ? <p className="m-0 text-sm leading-7 text-slate-600">{language.noteText}</p> : null}
              {country === '40' ? <p className="m-0 text-sm leading-7 text-slate-600">{language.noteText3}</p> : null}
            </section>

            <section className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
              <h2 className="m-0 mb-4 text-xl font-normal text-marival-navy">{language.text8}</h2>

              {country === '167' ? (
                mexicoAwardInfo
              ) : (
                <div className="rounded-xl bg-[linear-gradient(135deg,#2f7fcb_0%,#171d54_100%)] p-6 text-white">
                  <p className="m-0 text-base font-semibold leading-7">
                    {isSpanish ? 'Gana hasta $100 USD en TARJETA DE REGALO ELECTRÓNICA VÍA TANGO por cada ' : 'Earn up to $100 ELECTRONIC GIFT CARD VIA TANGO per '}
                    <b>{isSpanish ? 'RESERVA REGISTRADA Y VERIFICADA' : 'Registered and Verified BOOKING'}</b>
                  </p>
                </div>
              )}

              {country === '167' ? (
                <div className="mt-4">
                  <p className="m-0 text-sm leading-7 text-slate-600">{language.text21}</p>
                  <NavLink
                    className="mt-4 inline-flex items-center rounded-lg bg-marival-navy px-4 py-3 text-sm font-semibold text-white hover:bg-marival-ink hover:text-white"
                    to="/trackredeem"
                  >
                    {language.text10}
                  </NavLink>
                </div>
              ) : null}

              <div
                className="mt-4 text-sm font-semibold leading-7 text-slate-500 [&_a]:font-semibold [&_a]:text-marival-sky"
                dangerouslySetInnerHTML={{ __html: language.text22 }}
              />
            </section>
          </aside>

          {showBonusTable ? (
            <section className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm md:p-7 lg:col-span-2">
              {country === '40' ? null : <h2 className="m-0 mb-4 text-xl font-semibold text-marival-navy">{language.text2}</h2>}
              <ul className="m-0 list-disc space-y-3 pl-5 text-sm leading-7 text-slate-600">
                {country === '40' ? null : (
                  <li>
                    <p className="m-0">{language.text3}</p>
                    <p className="m-0 font-semibold text-marival-sky">{language.text4}</p>
                  </li>
                )}
                {country === '40' ? null : <li>{language.text5}</li>}
                {country === '40' ? null : <li>{language.text6}</li>}
                <li>{language.text7}</li>
              </ul>
            </section>
          ) : null}

          <section className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm md:p-7 lg:col-span-2">
            {country === '167' ? (
              <div className="space-y-4 text-sm leading-7 text-slate-600">
                <p className="m-0">{language.text11}</p>
                <p className="m-0">{language.text12}</p>
                <p className="m-0">{language.text13}</p>
                <p className="m-0">{language.note1}</p>
                <p className="m-0">{language.note2}</p>
              </div>
            ) : (
              <div className="text-sm leading-7 text-slate-600">
                <ul className="m-0 list-disc space-y-3 pl-5">
                  <li>{isSpanish ? 'El programa Marival Rewards está sujeto a cambios sin previo aviso.' : 'Marival Rewards Program subject to changes without prior notice.'}</li>
                  <li>{isSpanish ? 'Permite de 3 a 5 semanas para que los premios sean validados después de la salida del cliente.' : "Please allow 3-5 weeks for awards to be validated after client's departure"}</li>
                  <li>
                    <b>{isSpanish ? 'Bodas y grupos sociales:' : 'Wedding and Social Groups:'}</b>
                    <ul className="mt-2 list-disc space-y-2 pl-5">
                      <li>{isSpanish ? 'Estos grupos califican para premios dentro del programa.' : 'These groups will qualify for rewards under the program.'}</li>
                      <li>{isSpanish ? 'No aplica para grupos M.I.C.E.' : 'Not applicable for M.I.C.E groups'}</li>
                    </ul>
                  </li>
                  <li>
                    <b>{isSpanish ? 'Incentivos adicionales:' : 'Additional Incentives:'}</b>
                    <ul className="mt-2 list-disc space-y-2 pl-5">
                      <li>
                        {isSpanish ? 'Los agentes siguen siendo elegibles para ' : 'Agents are still eligible for '}
                        <b>{isSpanish ? 'otros incentivos para agentes' : 'other agent incentives'}</b>
                        {isSpanish ? ' además del programa Marival Rewards.' : ' in addition to the Marival Rewards program.'}
                      </li>
                    </ul>
                  </li>
                  <li>
                    <b>{isSpanish ? 'Nota:' : 'Note:'}</b>
                    {isSpanish ? ' Las reservas calificadas pueden canjearse por noches gratis o Tarjetas de Regalo TANGO hasta ' : ' Qualified bookings are eligible to be redeemed for free nights or TANGO Gift Cards up to '}
                    <b>{isSpanish ? 'dos años' : 'two years'}</b>
                    {isSpanish ? ' después de haber sido otorgadas. Los puntos por vencer serán removidos el ' : ' after being awarded. Expiring points will be removed on '}
                    <b>{isSpanish ? '31 de diciembre' : 'December 31st'}</b>
                    {isSpanish ? ' de cada año calendario.' : ' each calendar year.'}
                  </li>
                </ul>

                <div className="mt-5">
                  <b>{isSpanish ? 'Términos para puntos otorgados previamente (finales de 2024):' : 'Terms for Previously Awarded Points (End of 2024):'}</b>
                  <ul className="mt-2 list-disc space-y-2 pl-5">
                    <li>
                      {isSpanish
                        ? 'Los puntos otorgados hasta finales de 2024 seguirán los términos existentes. Para cualquier duda, los Travel Advisors deben contactar a su '
                        : 'Points awarded up to the end of 2024 will follow the existing terms. For any concerns, Travel Advisors should reach out to their '}
                      <b>Business Development Manager</b>
                      {isSpanish ? ' para recibir apoyo.' : ' for further support.'}
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </section>
        </div>
      </div>
    );
}

export default DetailsFAQs;
